import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface DrawerStore {
  isMobileDrawerOpen: boolean;
  isDesktopDrawerOpen: boolean;
  setIsDesktopDrawerOpen: (isOpen: boolean) => void;
  setIsMobileDrawerOpen: (isOpen: boolean) => void;
}

export const useDrawerStore = create<DrawerStore>()(
  persist(
    (set) => ({
      isMobileDrawerOpen: false, // not persisted
      isDesktopDrawerOpen: true, // persisted
      setIsDesktopDrawerOpen: (isDesktopDrawerOpen) =>
        set({ isDesktopDrawerOpen }),
      setIsMobileDrawerOpen: (isMobileDrawerOpen) => set({ isMobileDrawerOpen })
    }),
    {
      name: "drawer-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isDesktopDrawerOpen: state.isDesktopDrawerOpen
      })
    }
  )
);
